import axios from "axios";
import { backendUrl } from "../utils/url";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  headers: { "Content-Type": "application/json" },
});

// اضافه کردن توکن (مشابه بقیه API‌ها)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || cookies.get("jwt-auth");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// دریافت گزاره‌های یک درس
export const getStatementsByLesson = async (lessonId) => {
  try {
    const response = await api.get(`/evaluation/getByLesson/${lessonId}`);
    return response.data;
  } catch (err) {
    return err.response?.data || { message: "خطا در دریافت گزاره‌ها" };
  }
};

// ایجاد گزاره جدید
export const createStatement = async (data) => {
  try {
    const response = await api.post("/evaluation/create", data);
    return response;
  } catch (err) {
    return err.response?.data || { message: "خطا در ایجاد گزاره" };
  }
};

// ویرایش گزاره
export const updateStatement = async (data) => {
  try {
    const response = await api.put(`/evaluation/update`, data);
    return response;
  } catch (err) {
    return err.response?.data || { message: "خطا در ویرایش گزاره" };
  }
};

// حذف گزاره
export const deleteStatement = async (id) => {
  try {
    const response = await api.delete(`/evaluation/delete/${id}`);
    return response.data;
  } catch (err) {
    return err.response?.data || { message: "خطا در حذف گزاره" };
  }
};

// دریافت همه گزاره‌ها با فیلتر (اختیاری)
export const getAllStatements = async (filters = {}) => {
  try {
    const response = await api.get("/evaluation/all", { params: filters });
    return response.data;
  } catch (err) {
    return err.response?.data || { message: "خطا در دریافت گزاره‌ها" };
  }
};
